import { Component } from 'react';
import { connect } from 'react-redux';

// eslint-disable-next-line import/no-cycle
import AddCreditCardModal from 'profile/creditCard/AddModal';
import EditCreditCardModal from 'profile/creditCard/EditModal';
import {
  getClubMembership,
  editClubMembership
} from 'redux/clubMemberships/actions';

import CardsOnFile from './CardsOnFile';
import DisplayCreditCard from './DisplayCreditCard';

class PaymentDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: null,
      editCreditCardId: null
    };
  }

  handleEditCreditCard = (id) => {
    this.setState({
      modal: 'editCreditCard',
      editCreditCardId: id
    });
  };

  handleAddCreditCard = () => {
    this.setState({
      modal: 'addCreditCard',
      editCreditCardId: null
    });
  };

  handleCreditCardSuccess = (creditCard) => {
    const { props } = this;
    const clubMembershipId = props.clubMembership.id;
    const data = {
      customerCreditCardId: creditCard.id
    };
    const successFunction = () => {
      this.handleCloseModal();
    };
    props.editClubMembership(clubMembershipId, data, successFunction);
  };

  handleCardsOnFile = () => {
    this.setState({
      modal: 'cardsOnFile'
    });
  };

  handleCloseModal = () => {
    this.setState({
      modal: null,
      editCreditCardId: null
    });
  };

  render() {
    const { clubMembership } = this.props;
    const { state } = this;
    const object = {
      modal: state.modal,
      editCreditCardId: state.editCreditCardId,
      handleCloseModal: this.handleCloseModal,
      handleAddCreditCard: this.handleAddCreditCard,
      handleEditCreditCard: this.handleEditCreditCard,
      onHandleCreditCardSuccess: this.handleCreditCardSuccess,
      handleCardsOnFile: this.handleCardsOnFile
    };
    return (
      <>
        <DisplayCreditCard
          clubMembership={clubMembership}
          onEdit={this.handleCardsOnFile}
        />
        {renderModal(object)}
      </>
    );
  }
}

const renderModal = (object) => {
  const {
    modal,
    editCreditCardId,
    handleCloseModal,
    handleEditCreditCard,
    handleAddCreditCard,
    handleCardsOnFile,
    onHandleCreditCardSuccess
  } = object;
  switch (modal) {
    case 'editCreditCard': {
      return (
        <EditCreditCardModal
          onCloseModal={handleCloseModal}
          creditCardId={editCreditCardId}
          cancelFunction={handleCardsOnFile}
          onEditCreditCard={onHandleCreditCardSuccess}
        />
      );
    }
    case 'addCreditCard': {
      return (
        <AddCreditCardModal
          onCloseModal={handleCloseModal}
          cancelFunction={handleCardsOnFile}
          onAddCreditCard={onHandleCreditCardSuccess}
        />
      );
    }
    case 'cardsOnFile': {
      return (
        <CardsOnFile
          onCloseModal={handleCloseModal}
          handleEditCreditCard={handleEditCreditCard}
          handleAddCreditCard={handleAddCreditCard}
          onSelectCreditCard={onHandleCreditCardSuccess}
        />
      );
    }
    default: {
      return null;
    }
  }
};

export default connect(null, {
  getClubMembership,
  editClubMembership
})(PaymentDetails);
